import React, { useState } from "react";
import { login } from "../../../api/services/loginService";
import { LoginRequest } from "../../../api/requests/loginService";
import logo from "../../../images/logo_verticale.jpeg";
import { Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import CustomButton from "../../custom/CustomButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomCard from "../../custom/CustomCard";
import { darkColor } from "../../custom/utils";
import CustomText from "../../custom/CustomText";
import CustomInput from "../../custom/CustomInput";
import CustomIconButton from "../../custom/CustomIconButton";
import { useNavigate } from "react-router-dom";
import { mainUrl, resetPasswordPageUrl } from "../costants";
import { checkUser } from "../../../api/services/userService";

const LoginPanel: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);

  document.body.style.backgroundColor = darkColor;

  const checkLogin = (e: any) => {
    // e.preventDefault();
    // e.stopPropagation();
    checkUser(email + "@sct.com").then((res: any) => {
      console.log(res);
    });
    login({ email: email + "@sct.com", password: password } as LoginRequest)
      .then((res: any) => {
        if (res && res.status && res.status === "success") {
          navigate(mainUrl);
          localStorage.setItem("isSCTLogin", "true");
        } else {
          enqueueSnackbar(res?.error?.message || t("incorrectCredentials"), {
            variant: "error",
            preventDuplicate: true,
          });
        }
      })
      .catch((e) => {
        enqueueSnackbar(t("incorrectCredentials"), {
          variant: "error",
          preventDuplicate: true,
        });
        console.log(e);
      });
  };

  return (
    <Grid height="100vh" container justifyContent="center" alignItems="center">
      <Grid item container xs={12} justifyContent="center" alignItems="center">
        <Grid item xs={11} md={8}>
          <CustomCard
            content={
              <Grid item container spacing={3}>
                <Grid item xs={12}>
                  <img
                    src={logo}
                    alt="logo"
                    width="15%"
                    style={{ marginLeft: "42%", marginRight: "42%" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomText label={t("welcomeBack")} type="h3" />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label={t("username")}
                    value={email}
                    handleChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label={t("password")}
                    type={showPassword ? "text" : "password"}
                    value={password}
                    handleChange={(e) => setPassword(e.target.value)}
                    endAdornment={
                      <CustomIconButton
                        type="outlined"
                        icon={showPassword ? <VisibilityOff /> : <Visibility />}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    }
                  />
                </Grid>
                <Grid item container spacing={2}>
                  <Grid item xs={12} md>
                    <CustomButton
                      fullWidth
                      type="outlined"
                      label={t("resetPassword")}
                      onClick={() => navigate(resetPasswordPageUrl)}
                    />
                  </Grid>
                  <Grid item xs={12} md>
                    <CustomButton
                      fullWidth
                      type="contained"
                      label={t("login")}
                      onClick={checkLogin}
                    />
                  </Grid>
                </Grid>
              </Grid>
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginPanel;
